import { render } from "./MultiCarousel.vue?vue&type=template&id=b6cdbc3c&scoped=true"
import script from "./MultiCarousel.vue?vue&type=script&lang=js"
export * from "./MultiCarousel.vue?vue&type=script&lang=js"

import "./MultiCarousel.vue?vue&type=style&index=0&id=b6cdbc3c&lang=css"
import "./MultiCarousel.vue?vue&type=style&index=1&id=b6cdbc3c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6cdbc3c"],['__file',"src/components/mdbvue/pro/Advanced/MultiCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6cdbc3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6cdbc3c', __exports__)) {
    api.reload('b6cdbc3c', __exports__)
  }
  
  module.hot.accept("./MultiCarousel.vue?vue&type=template&id=b6cdbc3c&scoped=true", () => {
    api.rerender('b6cdbc3c', render)
  })

}


export default __exports__